<template>
 <div :class="windowClass">
    <v-row no-gutters>
            <v-col xs="12" class="ma-2">
                    <v-card class="pa-2">
                        <v-card-title>
                        <v-icon large left color="secondary">mdi-account-tie</v-icon> MANAGE USERS  
                        <v-spacer></v-spacer>
                       <span style="width:200px;">
                        <v-text-field
                            v-model="search"
                            append-icon="mdi-magnify"
                            label="Search"
                            dense
                            outlined
                            single-line
                            hide-details
                        ></v-text-field>
                       </span>
                         <span style="width:200px; margin-left: 5px;">
                          <v-select
                           :items="['superadmin', 'admin', 'officer', 'salesman', 'checker']"
                              v-model="search"
                              label="Type"
                              dense
                              outlined
                              single-line
                              hide-details
                          ></v-select>
                        </span>
                       <v-divider class="ml-4" vertical/>
                        <v-btn color="success" text @click="user={}, state='new', form=true" small><v-icon left>mdi-plus-box</v-icon> Add User</v-btn>
                        </v-card-title>
                             <v-data-table
                                class="va-table"
                                dense
                                :headers="headers"
                                :search="search"
                                :items="users"
                                >
                                <template v-slot:body="{ items }">
                                    <tbody>
                                    <tr v-for="(item,index) in items" :key="index">
                                        <td>
                                        <v-icon x-small left color="warning" @click="user=item, state='update', form=true" >mdi-pencil</v-icon>
                                        {{ item.username }}</td>
                                         <td>{{ item.fullname }}</td>
                                        <td>{{ item.role }}</td>
                                        <td>{{ item.assign_code}}</td>
                                    </tr>
                                    </tbody>
                                </template>
                                </v-data-table>
                    </v-card>
            </v-col>
            
    </v-row>
    <v-row>
         <v-col xs="6" class="ma-2">
            <v-card class="pa-2">
                        <v-card-title>
                        <v-icon  left color="secondary">mdi-storefront</v-icon> MANAGE OFFICE  
                         <v-spacer></v-spacer>
                          <v-btn color="success" text @click="state='new', officeform=true" small><v-icon left>mdi-plus-box</v-icon> OFFICE</v-btn>
                        </v-card-title>
                             <v-data-table
                                class="va-table"
                                dense
                                :headers="officeheaders"
                                :items="offices"
                                >
                                <template v-slot:body="{ items }">
                                    <tbody>
                                    <tr v-for="(item,index) in items" :key="index">
                                      
                                        <td> 
                                          <v-icon left x-small color="warning" @click="state='update', office=item, officeform=true">mdi-pencil</v-icon>
                                          {{ item.name }}</td>
                                        <td>{{ item.address}}</td>
                                    </tr>
                                    </tbody>
                                </template>
                                </v-data-table>
                    </v-card>
             </v-col>
              <v-col xs="6" class="ma-2">

                    <v-card class="pa-2">
                        <v-card-title>
                        <v-icon  left color="secondary">mdi-home</v-icon> MANAGE SUPPLIERS  
                         <v-spacer></v-spacer>
                        <v-btn color="success" text @click="state='new', supplierform=true" small><v-icon left>mdi-plus-box</v-icon> Supplier</v-btn>
                        </v-card-title>
                             <v-data-table
                                class="va-table"
                                dense
                                :headers="supplierheaders"
                                :items="suppliers"
                                >
                                <template v-slot:body="{ items }">
                                    <tbody>
                                    <tr v-for="(item,index) in items" :key="index">
                                      
                                        <td>
                                         <v-icon left x-small color="warning" @click="state='update', supplier=item, supplierform=true">mdi-pencil</v-icon> {{ item.company }} 
                                        </td>
                                        <td>{{ item.person}}</td>
                                          <td>{{ item.number}}</td>
                                    </tr>
                                    </tbody>
                                </template>
                                </v-data-table>
                    </v-card>
             </v-col>
    </v-row>
    <va-user-form :show="form" :user="user" :state="state" @DialogEvent="formEvent" />
     <va-supplier-form :show="supplierform" :item="supplier" :state="state" @DialogEvent="sfEvent" />
     <va-office-form :show="officeform" :item="office" :state="state" @DialogEvent="ofEvent" />
  </div>
</template>
<script>
import {
  mapMutations
} from 'vuex'
  export default {
    data: () => ({
      supplierform: false,
      officeform: false,
        form: false,
        state: 'new',
        user: {},
        search:'',
        users:[],
        offices:[],
        office:{},
        supplier:{},
        suppliers:[],
        headers: [
            { text: 'Username', value:"username"},
            { text: 'Fullname', value:"fullname"},
            { text: 'Role', value:"role"},
            { text: 'Route', value: "assign_code" }
        ],
         officeheaders: [
            { text: 'Name', value:"name"},
            { text: 'Address', value:"address"}
        ],
         supplierheaders: [
            { text: 'Company', value:"company"},
            { text: 'Contact Person', value:"person"},
            { text: 'Contact No.', value:"number"}
        ],

    }),
    beforeCreate: function () {
      if (!this.$session.exists()) {
        this.$router.push('/')
      }
    },
    created() {
       if (this.$session.exists()) {
          this.$http.defaults.headers.common['Authorization'] = 'Bearer ' + this.$session.get('jwt')
          this.SET_MENUS()
          this.setLoggedIn(true) 
          this.getAccounts()
           this.getOffices()
           this.getSupliers()
           this.GET_SETTINGS()
        }
    },
    computed:{
       windowClass() {
        if(this.$store.state.responsive){
          return "va-reponsive"
        } else {
          return "va-not-reponsive"
        }
      },
    },
    methods: {
      ...mapMutations(['setAlert', 'setAlertColor', 'setAlertText', 'setLoggedIn']),
      sfEvent(){
        this.supplierform = false
        this.getSupliers()
      },
       ofEvent(){
        this.officeform = false
        this.getOffices()
      },
      formEvent(data){
          this.form = false
          if(data.action != 'close') {
              this.user = data.user
              this.Save()
          }
      },
       getSupliers() {
            this.$http.post("supplier/list", {}).then(response => {
                response.data.items !=null?this.suppliers=response.data.items:this.suppliers=[]
               }).catch(e => {
                console.log(e.data)
            })
        },
      getOffices() {
            this.$http.post("office/list", {}).then(response => {
                response.data.items !=null?this.offices=response.data.items:this.offices=[]
               }).catch(e => {
                console.log(e.data)
            })
        },
      getAccounts: function() { 
        this.$http.post("user/list", JSON.stringify({})).then(response => {
            response.data.data != null?this.users = response.data.data:this.users =[]
        }).catch(e => {
        console.log(e.data)
        })
     },
      Save: function() {
        let method = 'user/register'
        this.state != 'new'?method='user/update':method = 'user/register'
        
        this.$http.post(method, this.user).then(response => {
          this.GET_RESPONSE(response)
            this.getAccounts()
        }).catch(e => {
        console.log(e)
        })
     },
    }
  }
</script>